<template>
  <section id="section__start" class="view-container">
    <div class="width-100">
      <v-row no-gutters class="mt-10">
        <v-col cols="12">
          <p class="font--p-3">서류만 미리 제출하면 <br />빠르게 당겨 받을 수 있어요!</p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <img src="@/assets/images/apply/clock.png" class="clock" />
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-5">
        <v-card class="card">
          <v-col cols="12">
            <v-card-text class="font--m-3">미리 준비하면 좋은 서류</v-card-text>
            <v-card-text class="font-size--18">
              신분증 <br />
              사업자등록증 <br />
              경남은행 통장 사본 <br />
              소득금액증명원 <br />
            </v-card-text>
          </v-col>
        </v-card>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <p class="font-size--18 color--nice">
            서류를 준비하셨으면<br />
            1분이면 끝나요!
          </p>
        </v-col>
      </v-row>

      <BasicButton :to="{ path: '/documents' }">미리 정보 입력 ></BasicButton>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
#section__start {
  text-align: center;

  .clock {
    width: 100%;
    height: 210px;
    object-fit: contain;
  }

  .card {
    width: 100%;
    background-color: #e5f6ff;
  }
}
</style>
